import React from 'react';
import { motion } from 'framer-motion';
import { ArrowIcon } from './icons/ArrowIcon';
export function FinalCTA() {
  return <section className="py-16 px-4 bg-[#3D3028] text-[#FAF8F4] text-center" data-id="element-58">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-59">
        <h2 className="text-2xl md:text-4xl font-semibold" data-id="element-60">
          EL MOMENTO ES AHORA
        </h2>

        <div className="flex flex-wrap justify-center gap-4 text-xs font-medium text-[#D4AF7A]" data-id="element-61">
          <span data-id="element-62">Oferta por tiempo limitado</span>
          <span data-id="element-63">Más de 100 personas viendo esta página ahora</span>
          <span data-id="element-64">Los bonos solo están disponibles HOY</span>
        </div>

        <div className="bg-[#FAF8F4]/5 p-8 rounded-2xl border border-[#FAF8F4]/10 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-65">
          <p className="text-xl md:text-2xl font-semibold mb-1" data-id="element-66">
            Todo por solo $27 USD
          </p>
          <p className="text-[#FAF8F4]/50 mb-6 text-xs" data-id="element-67">
            Pago único - Acceso de por vida
          </p>

          <motion.a href="https://www.hydraglosslips.com/cart/47717496684792:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-2 bg-[#E5A5A0] hover:bg-[#d99590] text-white font-semibold px-8 py-4 rounded-full text-base transition-colors duration-300" data-id="element-68">
            Accedé ahora al Master
            <ArrowIcon className="w-4 h-4" data-id="element-69" />
          </motion.a>

          <p className="mt-4 text-xs text-[#FAF8F4]/40 flex items-center justify-center gap-2" data-id="element-70">
            <ArrowIcon className="w-3 h-3" data-id="element-71" />
            Hacé clic y reservá tu lugar ahora
          </p>
        </div>
      </div>
    </section>;
}